<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Student Action Projects</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Student Action Projects engage students to turn their awareness of social causes into action.</li>
                        </ol>
                    </nav>
                    <a v-if="current_user_is_free" href="https://www.designforchange.us/contact-us" target="_new" class="btn btn-danger float-lg-right mr-5 mb-3 mb-lg-0 excess-margin">
                        <img src="/images/icons/archive-light.svg" class="mr-1" alt="">
                        This feature is part of the School Subscription. Contact Us for more details.
                    </a>
                </div>
            </template>

            <hr class="my-0">

            <section class="embed">
                <iframe src="https://www.designforchange.us/action-projects-embed" v-if="current_user_is_free" class="frame" ref="frame"></iframe>
                <iframe src="https://www.designforchange.us/action-projects-embed-paid" v-if="current_user_is_paid" class="frame" ref="frame"></iframe>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
export default {
    name: "EmbedProjectLearn",
    components: {AdminLayout, AppContentPane},

    computed: {
        frame(){
            return this.$refs.frame;
        }
    },

    methods: {
        resizeFrame(){
            setTimeout(() => {
                this.frame.height = '3500px';
            }, 100);
        },
    },

    mounted() {
        this.setTitle("Student Action Projects");
    },

}
</script>
<style lang="scss" scoped>

.excess-margin{
    margin-top: -4.5em;
}

@media (min-width: 650px) and (max-width: 1199px){
    .excess-margin{
        margin-top: 0rem;
        width: 100%;
    }
}

.embed{
    font-size: 0;
}
.frame{
    width: 100%;
    border: none;
    border-radius: 0 0 6px 6px;
    height: 3500px;
}
</style>
